import { render, staticRenderFns } from "./Coverage.vue?vue&type=template&id=877808d6&scoped=true"
import script from "./Coverage.vue?vue&type=script&lang=js"
export * from "./Coverage.vue?vue&type=script&lang=js"
import style0 from "./Coverage.vue?vue&type=style&index=0&id=877808d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "877808d6",
  null
  
)

export default component.exports